import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Timeframe } from '@adornis/bh-timeframes/entities/Timeframe.js';
import type { InstitutionStatisticsPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { BHFilter } from '@adornis/buchungsheld-db/entities/bh-filter.js';
import { html } from 'lit';

@Entity()
export class TimeframeParticipationCountByImigrationHistory extends AdornisEntity {
  public static override _class = 'TimeframeParticipationCountByImigrationHistory';

  @Field(type => String)
  public timeframeID!: string;

  @DataLoadedField(type => Timeframe, doc => ({ _id: doc.timeframeID as any }))
  public timeframe!: Timeframe;

  @Field(type => [[String, Int]])
  public counts!: Array<[string, number]>;
}

export const icsrmInstitutionStatisticsPlugin: InstitutionStatisticsPlugin = {
  id: 'institution-statistics::icsrm',
  type: 'institution-statistics',
  render: (filter: BHFilter) => {
    return html` <icsrm-institution-statistics .filter=${filter}></icsrm-institution-statistics> `;
  },
};
